import React, { useState, useRef, useEffect } from "react";
import {
  Wrapper,
  Heading,
  Notes,
  ScrollWrapper,
  InnerWrapper,
  CommentIcon,
} from "./styled";
import NewNote from "../Common/NewNote";
import NoNotesButton from "../Common/NoNotesButton";
import Note from "../Common/Note";

const ChatBox = ({ notes = [], addNote, formDataId }) => {
  const [showChat, setShowChat] = useState(true);
  const scrollRef = useRef();

  useEffect(() => {
    scrollRef.current.scrollTo({
      top: scrollRef.current.scrollHeight,
    });
  }, [notes.length]);

  return (
    <React.Fragment>
      {showChat && (
        <Wrapper className="sp-chat-box">
          <Heading>Meddelande</Heading>
          <Notes>
            <ScrollWrapper ref={scrollRef}>
              <InnerWrapper>
                {notes.length === 0 && (
                  <NoNotesButton
                    icon={"fal fa-clipboard-list"}
                    heading="No.Notes"
                  />
                )}
                {notes.length !== 0 &&
                  notes.map((note, i) => {
                    return (
                      <Note
                        key={i}
                        type="external"
                        {...note}
                        removeNote={() => {}}
                      />
                    );
                  })}
              </InnerWrapper>
            </ScrollWrapper>
          </Notes>
          <NewNote type="internal" addNote={addNote} formDataId={formDataId} />
        </Wrapper>
      )}

      <CommentIcon
        className={`fal fa-${showChat ? "times" : "comment"}`}
        onClick={() => {
          setShowChat(!showChat);
        }}
      />
    </React.Fragment>
  );
};

export default ChatBox;
